"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _default(React) {
  var RenderField = /*#__PURE__*/function (_React$Component) {
    _inherits(RenderField, _React$Component);

    var _super = _createSuper(RenderField);

    function RenderField() {
      _classCallCheck(this, RenderField);

      return _super.apply(this, arguments);
    }

    _createClass(RenderField, [{
      key: "render",
      value: function render() {
        var input = this.props.input;
        var _this$props = this.props,
            children = _this$props.children,
            type = _this$props.type,
            autoSave = _this$props.autoSave,
            autoFocus = _this$props.autoFocus,
            autoComplete = _this$props.autoComplete,
            autoCapitalize = _this$props.autoCapitalize,
            onUpdate = _this$props.onUpdate,
            onInput = _this$props.onInput,
            disabled = _this$props.disabled,
            placeholder = _this$props.placeholder,
            readOnly = _this$props.readOnly,
            id = _this$props.id,
            step = _this$props.step,
            pattern = _this$props.pattern,
            maxLength = _this$props.maxLength,
            _this$props$meta = _this$props.meta,
            error = _this$props$meta.error,
            touched = _this$props$meta.touched;
        var submitEvent = new Event('submit', {
          bubbles: true,
          cancelable: true
        });
        var standardProps = {
          disabled: disabled,
          step: step,
          pattern: pattern,
          maxLength: maxLength,
          id: id,
          autoComplete: autoComplete,
          autoCapitalize: autoCapitalize,
          autoFocus: autoFocus
        };

        if (type === 'textarea') {
          return /*#__PURE__*/React.createElement("div", {
            className: "textarea ".concat(touched && error ? 'error' : '')
          }, /*#__PURE__*/React.createElement("textarea", _extends({}, input, standarProps, {
            readOnly: disabled,
            placeholder: placeholder,
            onBlur: function onBlur(e) {
              input.onBlur(e);
              e.persist();
              setTimeout(function () {
                if (typeof onUpdate === 'function') {
                  onUpdate(e.target.value);
                }

                if (autoSave) {
                  e.target.form.dispatchEvent(submitEvent);
                }
              }, 0);
            },
            onChange: function onChange(e) {
              input.onChange(e);
              e.persist();

              if (typeof onInput === 'function') {
                setTimeout(function () {
                  return onInput(e.target.value);
                }, 0);
              }
            }
          })), touched && error && /*#__PURE__*/React.createElement("span", {
            className: "error"
          }, error), children);
        }

        if (type === 'select') {
          if (placeholder && input.value) {
            input = (0, _lodash.default)(input, 'defaultValue');
          }

          return /*#__PURE__*/React.createElement("div", {
            className: "select-icon-wrap ".concat(touched && error ? 'error' : '')
          }, /*#__PURE__*/React.createElement("select", _extends({}, input, standardProps, {
            className: "".concat(placeholder && input.value === '' ? 'placeholder' : ''),
            readOnly: disabled,
            value: input.value || placeholder,
            onChange: function onChange(e) {
              input.onChange(e);
              e.persist();
              setTimeout(function () {
                e.target.classList.toggle('placeholder', e.target.value === '');

                if (typeof onUpdate === 'function') {
                  onUpdate(e.target.value);
                }

                if (autoSave) {
                  e.target.form.dispatchEvent(submitEvent);
                }
              }, 0);
            }
          }), placeholder ? /*#__PURE__*/React.createElement("option", {
            disabled: !disabled
          }, placeholder) : null, children), touched && error && /*#__PURE__*/React.createElement("span", {
            className: "error"
          }, error), /*#__PURE__*/React.createElement("i", null));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "input-".concat(type, " ").concat(touched && error ? 'error' : '')
        }, /*#__PURE__*/React.createElement("input", _extends({}, input, standardProps, {
          type: type,
          readOnly: disabled || readOnly,
          placeholder: placeholder,
          onBlur: function onBlur(e) {
            input.onBlur(e);
            e.persist();
            setTimeout(function () {
              if (typeof onUpdate === 'function') {
                onUpdate(e.target.value);
              }

              if (autoSave && type !== 'checkbox') {
                e.target.form.dispatchEvent(submitEvent);
              }
            }, 0);
          },
          onChange: function onChange(e) {
            e.persist();
            input.onChange(e, type === 'checkbox' ? e.target.checked : e.target.value);
            setTimeout(function () {
              if (typeof onInput === 'function') {
                onInput(e.target.value);
              } // checkboxes submit on change, not on blur


              if (autoSave && (type === 'checkbox' || type === 'radio')) {
                // note cancelable: false, this is important for checkboxes
                e.target.form.dispatchEvent(new Event('submit', {
                  bubbles: true,
                  cancelable: false
                }));
              }
            }, 0);
          }
        })), children, touched && error && /*#__PURE__*/React.createElement("span", {
          className: "error"
        }, error));
      }
    }]);

    return RenderField;
  }(React.Component);

  return RenderField;
}